import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import UserInfoPage from "./UserInfo";
import CollectPage from "../collect/Collect";
import SubscribePage from "../subscribe/Subscribe";
import TranslateLogPage from "../translate/TranslateLog";

export default class UserCenter extends Component {
  render() {
    return (
      // <Router>
        <Layout>
          <Switch>
            <Route path="/userCenter/userInfo"  component={UserInfoPage} />
            <Route path="/userCenter/collectLaw" key="collectLaw" component={CollectPage} />
            <Route path="/userCenter/collectFDA" key="collectFDA"  component={CollectPage} />
            <Route path="/userCenter/translateLaw" key="translateLaw"  component={TranslateLogPage} />
            <Route path="/userCenter/translateFDA" key="translateFDA"  component={TranslateLogPage} />
            <Route path="/userCenter/subscribeLaw" key="subscribeLaw"  component={SubscribePage} />
            <Route path="/userCenter/subscribeFDA" key="subscribeFDA"  component={SubscribePage} />
          </Switch>
        </Layout>
      // </Router>
    );
  }
}
